/*
  customsirge_carousel.js
  Purpose: Arrow controls + mouse drag-to-scroll + disabled-state for [data-customsirge-carousel]
           (CSS scroll-snap does the rest; touch & trackpad scroll natively).
  Owns:    [data-customsirge-carousel] behavior. No dependencies. Defer-loaded.
  Owner:   agent-foundation / feat/redesign-foundation   Updated: 2026-07-16
*/
(function () {
  var DRAG_THRESHOLD = 6; // px of travel before a press becomes a drag (not a click)

  function initCarousel(root) {
    var track = root.querySelector('[data-customsirge-carousel-track]');
    var prev = root.querySelector('[data-customsirge-carousel-prev]');
    var next = root.querySelector('[data-customsirge-carousel-next]');
    if (!track) return;

    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth * 0.8;
      var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0', 10) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function update() {
      if (!prev || !next) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= maxScroll;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);

    // ---- Mouse drag-to-scroll (touch/trackpad already scroll natively) ----
    var down = false, moved = false, startX = 0, startScroll = 0, pointerId = null, suppressClick = false;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; suppressClick = false;
      startX = e.clientX; startScroll = track.scrollLeft; pointerId = e.pointerId;
    });
    track.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pointerId) return;
      var dx = e.clientX - startX;
      if (!moved) {
        if (Math.abs(dx) < DRAG_THRESHOLD) return;
        moved = true;
        track.classList.add('is-dragging'); // CSS: kills smooth/snap + shows grabbing cursor while dragging
        try { track.setPointerCapture(pointerId); } catch (err) {}
      }
      e.preventDefault();
      track.scrollLeft = startScroll - dx;
    });
    function endDrag() {
      if (!down) return;
      down = false;
      if (moved) { track.classList.remove('is-dragging'); suppressClick = true; }
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    // Stop the native image/link ghost-drag from hijacking a scroll-drag
    track.addEventListener('dragstart', function (e) { if (down) e.preventDefault(); });
    // Eat the click that fires after a drag so card links / Add to Cart don't trigger
    track.addEventListener('click', function (e) {
      if (suppressClick) { e.preventDefault(); e.stopPropagation(); suppressClick = false; }
    }, true);

    update();
  }

  function init() {
    document.querySelectorAll('[data-customsirge-carousel]').forEach(initCarousel);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
